document.querySelectorAll("[data-custom-select]").forEach(function(element) {
    CustomSelect(element);
});

function CustomSelect(element) {
    let me = element;
    let select = me.querySelector('select');
    let options = select.querySelectorAll('option');
    let isMultiple = select.multiple;
    let listContent = document.createElement('div');
    listContent.classList.add('custom-select-options');
    listContent.innerHTML = '<ul></ul>';
    me.appendChild(listContent);

    // render
    renderCheckList();
    // open
    me.addEventListener('click', function(e) {
        if (me.contains(e.target) && !listContent.contains(e.target)) {
            me.classList.toggle('open');
        }
    });
    // close
    document.addEventListener('click', function(e) {
        if (!me.contains(e.target)) {
            me.classList.remove('open');
        }
    });
    // event: update UI on change
    select.addEventListener('change', updateUI);

    function renderCheckList() {
        let list = listContent.querySelector('ul');
        options.forEach(function(el) {
            let item = createAListItem(el);
            list.appendChild(item);
        });
    }

    function createAListItem(el) {
        let myId = makeid(8);
        let value = el.value;
        let text = el.textContent;
        let checked = el.selected;
        let listElement = document.createElement('li');
        listElement.setAttribute('data-key', myId);
        listElement.setAttribute('value', value);
        listElement.classList.toggle('selected', checked);
        listElement.textContent = text;

        // multi select with `select all` option
        if (isMultiple && el.dataset.all !== undefined) {
            listElement.setAttribute('data-all', '');
        }

        el.setAttribute('data-key', myId);

        // on click
        listElement.addEventListener('click', function() {
            // check current one
            if (isMultiple) {
                let prevSelected = listElement.classList.contains('selected');
                // if select `all` option
                if (el.dataset.all !== undefined) {
                    // uncheck others and select current option
                    if (!prevSelected) {
                        options.forEach(function(option) {
                            option.selected = false;
                        });
                        el.selected = !prevSelected;
                    }
                } else {
                    if (!prevSelected) {
                        // uncheck `select all` and select current option
                        select.querySelector('option[data-all]').selected = false;
                        el.selected = true;
                    } else {
                        // uncheck current one
                        el.selected = false;
                        // check `select all` if there isn't any selected option
                        if (select.querySelectorAll('option:checked').length === 0) {
                            select.querySelector('option[data-all]').selected = true;
                        }
                    }
                }
            } else {
                el.selected = true;
                // close popup
                me.classList.remove('open');
            }
            // trigger change event
            select.dispatchEvent(new Event('change'));
        });
        return listElement;
    }

    function updateUI() {
        options.forEach(function(el) {
            let myId = el.dataset.key;
            let listElement = listContent.querySelector(`li[data-key="${myId}"]`);
            let checked = el.selected;
            listElement.classList.toggle('selected', checked);
        });
    }
}

function makeid(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }